let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dVG7s")).then(() => parcelRequire('1S96L'));